module.exports = __webpack_public_path__ + "img/p4_title.3c16c504.png";